import axios from 'axios';
import api from '@/services/links_apis.js';

export const station_id = {

    namespaced: true,

    state:{
        infoStation: [],
        dataStation: [],
        rainfallA3: [],
        rainfallA25: [],
        loadingHydro: false,
        loadingAccele: false,
        loadingPhrea: false,
        loadingAirq: false,
        showMenu: false,
        error: false
    },

    actions:{
        async Get_Station_Id({commit},primaryKey){
            commit('Refresh_Sidebar');
            let key = primaryKey.toString();
            try{
                const INFO = await axios.post(api.station_info+key);
                const DATA = await axios.post(api.station_data+key);
                const A3 = await axios.post(api.precipitation_A3+key);
                const A25 = await axios.post(api.precipitation_A25,{
                    "id": primaryKey,
                    "period": "24"
                });

                commit('Set_Station_Info',INFO.data);
                commit('Set_Station_Data',DATA.data);
                commit('Set_A3',A3.data);
                commit('Set_A25',A25.data);
                commit('Open_Sidebar');
                commit('Change_State_Loading',5);
            }catch(e){
                console.log(e);
                commit('Open_Sidebar');
                commit('Change_State_Loading',5);
                commit('Change_State_Error'); 
            }
        },

        Close_Station({commit},index){
            commit('Close_Station',index);
        },

        Close_Sidebar({commit}){
            commit('Close_Sidebar');
        },

        Catch_Error({commit}){
            commit('Change_State_Error');
        }
    },

    mutations:{
        Set_Station_Info:(state, data) => {
            state.infoStation.unshift(data);
        },

        Set_Station_Data:(state, values) => {
            state.dataStation.unshift(values);
        },

        Set_A3:(state,data) => {
            state.rainfallA3.unshift(data);
        },

        Set_A25:(state,data) => {
            state.rainfallA25.unshift(data);
        },

        Change_State_Loading:(state,type) => {
            switch(type){
                case 0:
                    state.loadingHydro = true;
                    break;
                case 1:
                    state.loadingAccele = true;
                    break;
                case 2:
                    state.loadingPhrea = true;
                    break;
                case 3:
                    state.loadingAirq = true;
                    break;
                case 5:
                    state.loadingHydro = false;
                    state.loadingAccele = false;
                    state.loadingPhrea = false;
                    state.loadingAirq = false;
                    break;
            }
        },

        Change_State_Error:(state) => {
            state.error = !state.error;
        },

        Refresh_Sidebar(state){
            state.showMenu = false;
        },

        Open_Sidebar(state){
            state.showMenu = true;
        },

        Close_Sidebar(state){
            state.showMenu = false;
            state.infoStation = [];
            state.dataStation = [];
        },

        Close_Station(state,index){
            state.showMenu = false;
            state.infoStation.splice(index, 1);
            state.dataStation.splice(index, 1);
            state.rainfallA3.splice(index, 1);
            state.rainfallA25.splice(index, 1);
            state.showMenu = true;
            if(state.infoStation.length == 0){
                state.showMenu = false;
            }
        }
    }
};